import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import da from 'react-intl/locale-data/da';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';

import localeData from '../locales/data';

addLocaleData([...en, ...es, ...da, ...fr, ...it]);

class I18n extends Component {
  render() {
    const { lang, children } = this.props;
    const messages = localeData[lang] || localeData.en;

    return (
      <IntlProvider locale={lang} messages={messages}>
        {children}
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => {
  const { session } = state;

  return {
    lang: session.language,
  };
};

export default connect(mapStateToProps)(I18n);



// WEBPACK FOOTER //
// ./src/components/i18n.container.js